import React, { useContext, useState } from "react";
import { TextField, Grid, Button, Box, Typography, MenuItem, IconButton, Dialog, DialogContent, DialogTitle, DialogActions, Stack, Divider, List, Backdrop, CircularProgress } from "@mui/material";
import { Add, Check, ChurchOutlined, Close, Delete } from "@mui/icons-material";
import { API } from "../../conf";
import { Context } from "../../App";

export default function OffSpe(props) {
    const { updateConnect, exercice } = useContext(Context)
    const [load, setLoad] = useState(false)
    const [open ,SetOpen] = useState(false)
    const [action, setAction] = useState('')
    const [newOff, setNew] = useState('')
    const [is_deptm, setDeptm] = useState(false)
    const [customeSousPoste, setCustomeSP] = useState('') 
    const [index, setIndex] = useState() //pour la creation de sous-poste custome
    const [label, setLabel] = useState()
    const [eglises, setEglises] = useState([])

    function manageDialog(status, action='') {
        SetOpen(status);
        setAction(action);
        if (!status) {
            setNew('');
            setCustomeSP('')
        } 
    }

    function handleSelectLabel(e, index) {
        props.setOffSpe(old => old.map((off, i) => i=== index ? {libelle: e.split(':')[1], montant: off.montant, compte: e.split(':')[0]} : off))
        manageDialog(false);
    }

    function handleAnotherChurch() { console.log('handle another church')
        setLoad(true)
        fetch(API.concat(`/comptes/liaison/eglises?exercice=${exercice}`), {method: 'GET', headers:{
            Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
        }).then(async(response)=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            } else if (token && token !== sessionStorage.getItem('token') && token !== '') {
                sessionStorage.setItem('token', response.headers.get('x-auth-token'))
            }
            if (response.status === 200){
                const compteEglises = await response.json()
                setEglises(compteEglises)
            }
            setLoad(false)
        })
    }

    function handleSubmit() {
        fetch(API.concat(`/comptes/create`), {method: 'POST', headers:{
            Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, 
            body: JSON.stringify({libelle: newOff, is_offrande: true, type:'interne', is_hors_budget: true, eglise: props.eglise._id, is_deptm: is_deptm})
        }).then(async(response)=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            } else if (token && token !== sessionStorage.getItem('token') && token !== '') {
                sessionStorage.setItem('token', response.headers.get('x-auth-token'))
            }
            if (response.status === 200){
                const compte = await response.json()
                props.setOffSpeLabel(old => {old.unshift({libelle: compte.libelle, num:compte.num}); return old})
                handleSelectLabel({libelle: compte.libelle, num:compte.num}, open)
            }
        })
    }

    return(
        <Box rowGap={2} display="flex" flexDirection="column">
            {props.offSpe.map((offrande, index) =>
            <Stack key={index} direction="row" spacing={1} sx={{alignItems:'center'}}>
                {props.offSpe.length>1 && <IconButton aria-label="supprimer" onClick={()=>{ props.setOffSpe(old => old.slice(0, index).concat(old.slice(index+1))) }}>
                    <Delete/>
                </IconButton>}

                <TextField select fullWidth label={props.label} required={offrande.montant>0}
                slotProps={{ select: { MenuProps:{
                    disableAutoFocusItem: true,
                    disableAutoFocus: true, 
                }}}}   
                value={ Object.values(offrande).every(value => value === '' || value === 0 || value === null || value === undefined) ? '' : offrande.compte+':'+offrande.libelle}
                onChange={(event)=> {
                    handleSelectLabel(event.target.value, index)
                }}
                >
                    {props.offSpeLabel.sort((a,b)=>a.libelle<b.libelle?-1:1).map((label, index) => {
                        const items = [
                            <MenuItem key={index} value={label.num+':'+label.libelle} disabled={props.offSpe.some(off=> off.libelle === label.libelle)}>
                                <Typography sx={{textTransform:'capitalize', fontWeight:label.sous_postes?.filter(sp=>sp.activated).length>0||label.customize_sous_postes_activated ? 'bold': 'normal'}}>{label.libelle}</Typography> 
                            </MenuItem>,
                            ...label.sous_postes?.filter(sp=>sp.activated).sort((a,b)=>a.libelle<b.libelle?-1:1).map((sousPoste, index) => (
                                <MenuItem sx={{marginLeft:5, paddingBlock:0, marginBlock:0, fontStyle:'italic'}} key={label.num+sousPoste.libelle} 
                                value={label.num+':'+sousPoste.libelle} disabled={props.offSpe.some(off=> off.libelle === sousPoste.libelle && off.compte === label.num)}>
                                    <Typography sx={{textTransform:'capitalize'}}>{sousPoste.libelle}</Typography>
                                </MenuItem>
                            ))
                        ]
                        if (label.customize_sous_postes_activated) {
                            items.push(<Box key={label.num+'customize'} display='flex' justifyContent='center' marginTop={label.sous_postes?.filter(sp=>sp.activated).length>0 ? 0.5 : 0} >
                                <Button variant="outlined" sx={{alignSelf: 'center'}} onClick={()=> {setIndex(index); setLabel(label); manageDialog(true, 'new SP')}} startIcon={<Add/>}>Personnalisé</Button>
                            </Box>)
                        }
                        return items
                    }).flat()}
                    {props.isFedOff && (eglises.length>0 ? eglises.sort((a,b)=>a.libelle<b.libelle?-1:1).map((eglise, index) => (
                        <MenuItem key={index} value={eglise.num+':'+eglise.libelle} disabled={props.offSpe.some(off=> off.libelle === eglise.libelle && off.compte === eglise.num)}>
                            <Typography sx={{textTransform:'capitalize'}}>{eglise.libelle}</Typography>
                        </MenuItem>))
                    :<Box display='flex' flexDirection='column' alignItems='center' marginTop={1}>
                        <Button variant="clear" sx={{alignSelf: 'center', fontWeight:'bold'}} onClick={handleAnotherChurch} startIcon={<ChurchOutlined/>}>Autres églises</Button>
                    </Box>)}
                    {props.canAdd && <Box display='flex' flexDirection='column' alignItems='center' marginTop={1}>
                        <Divider sx={{width:'60%'}}/>
                        <Button variant="clear" sx={{alignSelf: 'center', fontWeight:'bold', marginTop:0.5}} onClick={()=> manageDialog(true, 'new compte')} startIcon={<Add/>}>Ajouter une offrande spécifiée</Button>
                    </Box>}
                </TextField>

                <TextField onFocus={()=>{if(offrande.montant===0) props.setOffSpe(old => {old[index].montant = ''; return [...old]})}}
                label="Montant(en €)" type="number" slotProps={{select: {shrink: true}, htmlInput: {step:"1", min:'0'}}}
                value={offrande.montant}
                onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0){
                    props.setOffSpe(old => {old[index].montant = Number(e.target.value); return [...old] })
                }else if(e.target.value===''){
                    props.setOffSpe(old => {old[index].montant = ''; return [...old] })
                }}}
                />
            </Stack>)}
            
            {props.offSpe.every(offrande => offrande.libelle!=='' && offrande.montant>0) && (props.offSpeLabel.length>props.offSpe.length || props.canAdd) &&
            <Button aria-label="ajouter une offrande spécifiée" variant="contained"
            sx={{'&:hover':{backgroundColor:'primary.darker'}}}
            onClick={()=> props.setOffSpe(old => old.concat([{libelle: '', montant:0, compte:''}]))}>
                <Add sx={{margin:0}}/> Ajouter une Offrande Spécifiée
            </Button>}

            <Dialog open={open} onClose={()=>{manageDialog(false)}} maxWidth={action==='new compte' ? 'xs' : 'sm'} fullWidth={true}>
                {action==='new compte'&&<>
                <DialogTitle>Ajouter une nouvelle Offrande spécifiée</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus={true}
                        required
                        margin="normal"
                        label="Libellé"
                        fullWidth
                        variant="standard"
                        value={newOff}
                        onChange={(e)=>setNew(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{setNew(''); SetOpen(-1)}}>Annuler</Button>
                    <Button disabled={newOff.replaceAll(' ', '').length < 2 } onClick={handleSubmit}>Enregistrer</Button>
                </DialogActions>
                </>}
                {action==='new SP' && <Stack key={label.num+'customizing'} direction="row" spacing={1} sx={{marginBlock:2, paddingInline:2}}>
                    <TextField autoFocus fullWidth size="small" label="Libellé" value={customeSousPoste} 
                    onKeyDown={(e)=>{if(e.key==='Enter' && customeSousPoste.length>0) {
                        props.setOffSpeLabel(old=>old.map(item=>(item.libelle+item.num)===(label.libelle+label.num) ? {...label, sous_postes: [...label.sous_postes, {libelle: customeSousPoste, activated: true}]}: item))
                        handleSelectLabel(label.num+':'+customeSousPoste, index)
                    }}}
                    onChange={(e)=>setCustomeSP(e.target.value.toUpperCase())} />
                    <IconButton variant="contained" disabled={customeSousPoste.length<=0} onClick={()=>{
                        props.setOffSpeLabel(old=>old.map(item=>(item.libelle+item.num)===(label.libelle+label.num) ? {...label, sous_postes: [...label.sous_postes, {libelle: customeSousPoste, activated: true}]}: item))
                        handleSelectLabel(label.num+':'+customeSousPoste, index)
                    }}><Check fontSize="small" color={customeSousPoste.length>0 ? 'valide': 'inherit'}/></IconButton>
                    <IconButton aria-label="fermer" onClick={()=>manageDialog(false)} sx={{alignSelf:'center'}}><Close fontSize="small"/></IconButton>
                </Stack>}
                {action==='églises' && <>
                    <DialogTitle>Choisir une église</DialogTitle>
                    <DialogContent>
                        <List>
                            {load ? <Typography>Chargement...</Typography> : eglises.length > 0 ? eglises.map((eglise, index) => (
                                <MenuItem key={index} value={eglise._id} onClick={()=>{props.setOffSpe(old => old.concat([{libelle: eglise.libelle, montant:0, compte: eglise.num}])); manageDialog(false)}}>
                                    <Typography sx={{textTransform:'capitalize'}}>{eglise.libelle}</Typography>
                                </MenuItem>
                            )) : <Typography>Aucune église trouvée</Typography>}
                        </List>
                    </DialogContent>
                </>}
            </Dialog>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}